// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inmi1A0MNcJ1t0HOvp9J {
  background: rgba(30, 30, 30, 0.8);
  backdrop-filter: blur(8px);
  height: auto;
  border-radius: 6px;
  z-index: 2;
  position: relative;
  align-items: center;
  display: flex;
  column-gap: 1px;
  padding: 4px;
  transition: 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.Inmi1A0MNcJ1t0HOvp9J .vnsB3UCBw4e9OF6hxfqQ {
  width: 1px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 0 4px;
}
.Inmi1A0MNcJ1t0HOvp9J button {
  border-radius: 4px;
  width: 50px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
}
.Inmi1A0MNcJ1t0HOvp9J button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.Inmi1A0MNcJ1t0HOvp9J button.etChb9UkIhgSmSMD4tI2 {
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/ActionBar/ActionBar.module.scss"],"names":[],"mappings":"AAEA;EACE,iCAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,4BAAA;EACA,wCAAA;AAAF;AAEE;EACE,UAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;AADJ;AAGI;EACE,0CAAA;AADN;AAII;EACE,0CAAA;EACA,YAAA;AAFN","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Inmi1A0MNcJ1t0HOvp9J`,
	"divider": `vnsB3UCBw4e9OF6hxfqQ`,
	"active": `etChb9UkIhgSmSMD4tI2`
};
export default ___CSS_LOADER_EXPORT___;
